import React, { useState, useEffect, useMemo } from "react";
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";

import "./index.css"

import PaymentSummary from "./components/PaymentSummary";
import PaymentRequest from "./components/PaymentRequest";
import PaymentHistory from "./components/PaymentHistory";
import SellerPOSummary from "./components/SellerPOSummary";

import { getSellerPOBySellerPOId } from "../../services/api/sellerPO";
import { fetchApprovals, fetchCompanyCreditPeriods, fetchIncoTerms, fetchStatus } from "../../services/redux/reducers/commonThunk";
import { getVendorPaymentBySellerPOId } from "../../services/api/vendorPayment";
import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { getCompanyById } from "../../services/api/company";
import { getApprovalInstancesByDocNo } from "../../services/api/approvalInstances";
import { getBuyerPOItemsByBuyerPOIds } from "../../services/api/buyerPOItem";
import { getBuyerPOs } from "../../services/api/buyerPO";
import { getBuyerQuoteItems } from "../../services/api/buyerQuoteItem";
import { getTotalCompanyAmountByCompanyId } from "../../services/api/sellerPIPunch";
import { getTDSSections } from "../../services/api/tdsSections";
import { getAdjustmentNotes } from "../../services/api/adjustmentNotes";
import { getAdjustmentNoteItemsByAdjustmentNoteIds } from "../../services/api/adjustmentNoteItems";
import { getMaterialMasterAndTempMaterialIds } from "../../services/api/materialMaster";
import { getSellerReqsByBuyerReqIds } from "../../services/api/sellerReq";

import Loading from "../../common/Loading";
import { constructVPWiseSellerPOPaymentDetails, getApprovalRequestStatusDetails, getApprovalStatus, getSellerPOApprovals, round } from "../../utils";

import TableSkeleton from "../../skeletons/Table";
import RectangleRowSkeleton from "../../skeletons/RectangleRow";
import { getPMCompanyConfig } from "../../setup/pmCompanyConfig";
import { searchMaterialMandatoryUseFromStock } from "../../services/api/materialMandatoryUseFromStock";
import _ from "lodash";


const VendorPaymentSummary = () => {
    const { sellerPOId } = useParams()
    const dispatch = useDispatch()

    const statusList = useSelector((state) => state.common.status)
    const companyCreditPeriods = useSelector(state => state.common.companyCreditPeriods)
    const approvals = useSelector((state) => state.common.approvals)
    const incoTerms = useSelector((state) => state.common.incoTerms)
    
    const [sellerPO, setSellerPO] = useState(null)
    const [sellerPOItems, setSellerPOItems] = useState(null)
    const [sellerPIPunch, setSellerPIPunch] = useState(null)
    const [sellerPIPunchItems, setSellerPIPunchItems] = useState(null)
    const [sellerReqs, setSellerReqs] = useState([])
    const [sellerReqItems, setSellerReqItems] = useState([])
    const [sellerGRNQCPunch, setSellerGRNQCPunch] = useState(null)
    const [sellerDebitNotes, setSellerDebitNotes] = useState([])
    const [sellerDebitNoteItems, setSellerDebitNoteItems] = useState([])
    const [materialDetails, setMaterialDetails] = useState([])
    const [sellerPOPaymentDetails, setSellerPOPaymentDetails] = useState([])
    const [vendorPaymentReq, setVendorPaymentReq] = useState({})
    const [vendorPayments, setVendorPayments] = useState([])
    const [paymentTerms, setPaymentTerms] = useState({})
    const [isLoading, setIsLoading] = useState(true)
    const [buyerReq, setBuyerReq] = useState({})
    const [nonRoutedSellerPOsInfo, setNonRoutedSellerPOsInfo] = useState([])
    const [materialMandatoryUseFromStock, setMaterialMandatoryUseFromStock] = useState([])

    const [approvalRequestStatusDetails, setApprovalRequestStatusDetails] = useState([])
    const [requiredApprovals, setRequiredApprovals] = useState([])
    const [sellerCompanyDetails, setSellerCompanyDetails] = useState({})
    const [approvalInstances, setApprovalInstances] = useState([])
    const [buyerQuoteItems, setBuyerQuoteItems] = useState([])
    const [buyerPOItems, setBuyerPOItems] = useState([])
    const [tdsSections, setTdsSections] = useState([])

    const pmCompanyConfig = getPMCompanyConfig(sellerPO?.pmCompanyId)

    let requiredApprovalTypeIds = sellerPO?.expenseCategoryId ? pmCompanyConfig.expenseSellerPOApprovalTypeIds : pmCompanyConfig.sellerPOApprovalTypeIds
    let sellerPOApprovals = useMemo(() => {
        return approvals?.filter(eachApproval => requiredApprovalTypeIds.includes(eachApproval.approvalTypeId))
    }, [approvals, sellerPO?.sellerPOId])

    useEffect(()=>{
        dispatch(fetchCompanyCreditPeriods())
        dispatch(fetchStatus())
        dispatch(fetchApprovals())
        dispatch(fetchIncoTerms())
    }, [])

    useEffect(()=>{
        if(companyCreditPeriods.length > 0){
            getSellerPO()
        }
    }, [companyCreditPeriods])

    useEffect(() => {
        if (sellerPO?.sellerPOId && sellerPOItems?.length && materialDetails.length && sellerPOApprovals?.length && (buyerQuoteItems?.length || sellerPO?.expenseCategoryId)){
            calculateApprovalsNew()
        }
    }, [approvalInstances, sellerPO, sellerCompanyDetails, sellerPOItems, sellerPOApprovals, buyerQuoteItems, materialDetails])  

    /*let prendingApprovalsExist = false
    let allApprovalsApproved = false
    
    if(approvalRequestStatusDetails?.length){
        const pendingApprovalStatusDetails = approvalRequestStatusDetails.filter(eachReq => ["NOT REQUESTED", "REQUESTED", "REJECTED"].includes(eachReq.requestStatus))
        const approvedApprovalStatusDetails = approvalRequestStatusDetails.filter(eachReq => eachReq.requestStatus === "APPROVED")

        if(pendingApprovalStatusDetails.length){
            prendingApprovalsExist = true
        }
        if(approvedApprovalStatusDetails.length === approvalRequestStatusDetails.length){
            allApprovalsApproved = true
        }
    }*/

    let {
        pendingApprovalsExist
    } = getApprovalStatus(approvalRequestStatusDetails)

    if (sellerPIPunch?.length || (sellerPO && sellerPO.emailSent)){
        pendingApprovalsExist = false
    }

    if(pendingApprovalsExist){
        if(Date.parse(sellerPO.createdAt) < Date.parse(new Date("2024-06-17T00:00:00Z"))){
            pendingApprovalsExist = false
        }
    }

    const calculateApprovalsNew = () => {
        let updatedSellerPO = {...sellerPO}

        const relatedNonRoutedSellerPOsInfo = nonRoutedSellerPOsInfo.find(eachNonRoutedSellerPO => eachNonRoutedSellerPO.companyId === updatedSellerPO.companyId && eachNonRoutedSellerPO.docNo === updatedSellerPO.docNo)

        let updatedRequiredApprovals = getSellerPOApprovals({
            POApprovals: sellerPOApprovals, 
            sellerPO: updatedSellerPO, 
            sellerPOItems: sellerPOItems, 
            sellerCompanyDetails: sellerCompanyDetails, 
            buyerQuoteItems: buyerQuoteItems, 
            companyCreditPeriods: companyCreditPeriods, 
            sellerPIPunch: sellerPIPunch,
            materialMasterData: materialDetails,
            buyerReq: buyerReq,
            totalAmtFlag: true,
            buyerPOItems: buyerPOItems,
            sellerReqs: sellerReqs,
            sellerReqItems: sellerReqItems,
            nonRoutedSellerPOsInfo: relatedNonRoutedSellerPOsInfo,
            materialMandatoryUseFromStock: materialMandatoryUseFromStock
        })

        setRequiredApprovals(updatedRequiredApprovals)
        const approvalIns = approvalInstances ? approvalInstances : []
        const approvalRequestStatusDetails = getApprovalRequestStatusDetails({
            updatedRequiredApprovals: updatedRequiredApprovals, 
            approvalInstances: approvalIns, 
            approvals: sellerPOApprovals, 
            pmBranchId: sellerPO?.pmBranchId, 
            sellerPO: sellerPO
        })
        let updatedApprovalStatusDetails
        let prefillText = ""

        let totalSellerPOAmounts = 0
        let totalBuyerPOAmounts = 0

        sellerPOItems?.map(eachSellerPOItem => {
            let relatedBuyerPOItem = buyerPOItems?.find(eachBuyerPOItem => eachBuyerPOItem?.buyerPOItemId === eachSellerPOItem?.buyerPOItemId)
            totalSellerPOAmounts += eachSellerPOItem?.unitPrice
            totalBuyerPOAmounts += relatedBuyerPOItem?.bPOUnitPrice
        })

        let marginPercentage = ((totalBuyerPOAmounts - totalSellerPOAmounts) / totalBuyerPOAmounts) * 100
        let relatedIncoTerm = incoTerms?.find(eachIncoTerm => eachIncoTerm?.incoTermId === sellerPO?.incoTermId)
        
        if (marginPercentage){
            prefillText += `Margin: ${round(marginPercentage)} %, `
        }
        if (sellerPO?.paymentTerms){
            let paymentTermsDisplay = ''
            Object.keys(sellerPO?.paymentTerms)?.map(eachTerm => {
                let relatedPaymentTermValue = sellerPO?.paymentTerms[eachTerm]
                if (eachTerm === "creditPeriodId"){
                    let relatedCompanyCreditPeriod = companyCreditPeriods?.find(eachCreditPeriod => eachCreditPeriod?.creditPeriodId === relatedPaymentTermValue)
                    if (relatedCompanyCreditPeriod){
                        paymentTermsDisplay += `Credit: ${relatedCompanyCreditPeriod?.creditPeriodName}`
                    }
                }else{
                    if (relatedPaymentTermValue > 0){
                        paymentTermsDisplay += ` ${eachTerm}: ${relatedPaymentTermValue} `
                    }
                }
            })
            prefillText += `Payment Terms: ${paymentTermsDisplay}, `
        }
        if (sellerPO?.incoTermId && relatedIncoTerm){
            prefillText += `Inco Terms: ${relatedIncoTerm?.incoTerm} `
        }

        updatedApprovalStatusDetails = approvalRequestStatusDetails?.map(eachRequestDetail => {
            if (eachRequestDetail?.approvalTypeId === 17){
                return {...eachRequestDetail, remarks: prefillText, prefillText: prefillText}
            }
            return eachRequestDetail
        })
        setApprovalRequestStatusDetails(updatedApprovalStatusDetails)
    }

    const getSellerPO = async () => {
        setIsLoading(true)
        
        const response = await getSellerPOBySellerPOId(sellerPOId)
        const responseData = response.data

        if (responseData.sellerPO){
            responseData.sellerPO.totalPOAmount = parseFloat(responseData.sellerPO.totalPOAmount)
            responseData.sellerPO.totalPOTax = parseFloat(responseData.sellerPO.totalPOTax)
            responseData.sellerPO.totalItemAmountBeforeTax = parseFloat(responseData.sellerPO.totalItemAmountBeforeTax)
            responseData.sellerPO.totalItemAmountWithTax = parseFloat(responseData.sellerPO.totalItemAmountWithTax)
        }
        
        setSellerPO(responseData.sellerPO)
        setSellerPOItems(responseData.sellerPOItems)
        setSellerPIPunch(responseData.sellerPIPunch)
        setSellerPIPunchItems(responseData.sellerPIPunchItems)
        setSellerGRNQCPunch(responseData.sellerGRNQCPunch)
        setBuyerReq(responseData.buyerReq)
        setNonRoutedSellerPOsInfo(response.data.nonRoutedSellerPOsInfo)

        const sellerPIPunchIds = responseData.sellerPIPunch.map(eachSellerPIPunch => eachSellerPIPunch.sellerPIPunchId)

        let sellerDebitNoteRes
        let sellerDebitNoteItemsRes
        if(sellerPIPunchIds.length) {
            sellerDebitNoteRes = await getAdjustmentNotes({sellerPIPunchIds: sellerPIPunchIds, statusIds: [1, 7, 6], adjustmentTypeIds: [3, 9, 10]})
            if (sellerDebitNoteRes.failure) {
                setIsLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: 'Seller Debit Notes', detail: sellerDebitNoteRes.data.error }))
            }

            if(sellerDebitNoteRes.data.data?.length){
                const sellerDebitNoteIds = sellerDebitNoteRes.data.data.map(eachSellerDebitNote => eachSellerDebitNote.adjustmentNoteId)
                sellerDebitNoteItemsRes = await getAdjustmentNoteItemsByAdjustmentNoteIds({adjustmentNoteIds: sellerDebitNoteIds})
            }
        }

        const vendorPaymentResponse = await getVendorPaymentBySellerPOId(sellerPOId)
        if (vendorPaymentResponse.failure){
			dispatch(raiseToast({severity:'error', detail: vendorPaymentResponse.error, life: 3000}))
		}

        const sellerComapanyDetails = await getCompanyById(responseData.sellerPO.companyId)
        if (sellerComapanyDetails.failure) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'Seller Company Details', detail: sellerComapanyDetails.data.error, life: 3000 }))
        }

        const approvalInstanceRes = await getApprovalInstancesByDocNo({ docNo: responseData.sellerPO.docNo })
        if (approvalInstanceRes.failure) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'Approval instances', detail: approvalInstanceRes.data.error, life: 3000 }))
        }

        const companyTotalPIAmountRes = await getTotalCompanyAmountByCompanyId(responseData.sellerPO.companyId)
        if (companyTotalPIAmountRes.failure) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'Company Total PI Amount', detail: companyTotalPIAmountRes.data.error, life: 3000 }))
        }

        const tdsSectionsRes = await getTDSSections()
        if (tdsSectionsRes.failure) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'TDS Sections', detail: tdsSectionsRes.data.error }))
        }

        if(!responseData.sellerPO.expenseCategoryId){
            const buyerPORes = await getBuyerPOs({buyerPOIds: [responseData.sellerPO.buyerPOId], statusIds: [3, 4], permCheckNotRequired: true})
            if (buyerPORes?.failure){
                setIsLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: 'Buyer PO', detail: buyerPORes.data.error }))
            }

            const buyerPOItemsRes = await getBuyerPOItemsByBuyerPOIds([responseData.sellerPO.buyerPOId])
                if (buyerPOItemsRes?.failure){
                setIsLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: 'Buyer PO Items', detail: buyerPOItemsRes.data.error }))
            }

            const buyerQuoteItemRes = await getBuyerQuoteItems({buyerQuoteIds: [buyerPORes?.data?.data[0]?.buyerQuoteId]})
            if (buyerQuoteItemRes?.failure){
                setIsLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: 'Buyer Quote Items', detail: buyerQuoteItemRes.data.error }))
            }

            const sellerReqsRes = await getSellerReqsByBuyerReqIds({buyerReqIds: [responseData.sellerPO.buyerReqId], isItemsRequired: true})
            if (sellerReqsRes.failure){
                setIsLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: 'Seller Req', detail: sellerReqsRes.data.error }))
            }

            const materialIds = responseData.sellerPOItems.map(eachSellerPOItem => eachSellerPOItem.materialId)
            const materialMandatoryUseFromStockRes = await searchMaterialMandatoryUseFromStock({materialIds, paginator: false})
            if(materialMandatoryUseFromStockRes.failure){
                return dispatch(raiseToast({severity:'error', summary:'Mandatory material use from stock',  detail: materialMandatoryUseFromStockRes.data.error, life: 3000}))
            }

            setMaterialMandatoryUseFromStock(materialMandatoryUseFromStockRes.data.data)

            setSellerReqs(sellerReqsRes.data.sellerReqs)
            setSellerReqItems(sellerReqsRes.data.sellerReqItems)
            setBuyerQuoteItems(buyerQuoteItemRes?.data?.data)
            setBuyerPOItems(buyerPOItemsRes?.data)
        }

        const materialIds = responseData.sellerPOItems.map(eachSellerPOItem => eachSellerPOItem.materialId)
        
        const materialDetailsRes = await getMaterialMasterAndTempMaterialIds({materialIds: materialIds})
        setMaterialDetails(materialDetailsRes?.data)

        let vendorPayments = vendorPaymentResponse.data.filter(eachVendorPayment => eachVendorPayment.statusId !== 2)
        setVendorPayments(vendorPayments)

        setSellerCompanyDetails(sellerComapanyDetails?.data)
        setApprovalInstances(approvalInstanceRes.data)
        setTdsSections(tdsSectionsRes.data.data)

        let activeSellerDebitNotes = []
        let cancelledSellerDebitNotes = []

        let activeSellerDebitNoteItems = []
        let cancelledSellerDebitNoteItems = []
        
        if(sellerDebitNoteRes?.data.data.length){
            const updatedSellerDebitNotes = sellerDebitNoteRes.data.data.map(eachSellerDebitNote => {
                const relatedSellerDebitNoteItems = sellerDebitNoteItemsRes.data.filter(eachSellerDebitNoteItem => eachSellerDebitNoteItem.adjustmentNoteId === eachSellerDebitNote.adjustmentNoteId)

                eachSellerDebitNote.adjustmentNoteItems = relatedSellerDebitNoteItems
                return eachSellerDebitNote
            })
            activeSellerDebitNotes = updatedSellerDebitNotes.filter(eachSellerDebitNote => [1, 7].includes(eachSellerDebitNote.statusId))
            cancelledSellerDebitNotes = updatedSellerDebitNotes.filter(eachSellerDebitNote => [6].includes(eachSellerDebitNote.statusId))
            
            activeSellerDebitNoteItems = sellerDebitNoteItemsRes.data.filter(eachSellerDebitNoteItem => [1, 7].includes(eachSellerDebitNoteItem.statusId))
            cancelledSellerDebitNoteItems = sellerDebitNoteItemsRes.data.filter(eachSellerDebitNoteItem => [6].includes(eachSellerDebitNoteItem.statusId))
            
            setSellerDebitNotes(activeSellerDebitNotes)
            setSellerDebitNoteItems(activeSellerDebitNoteItems)
        }

        if(responseData.sellerPO?.paymentTerms){
            const sellerPODetails = {
                sellerPO: responseData.sellerPO,
                sellerPOItems: responseData.sellerPOItems,
                sellerPIPunch: responseData.sellerPIPunch,
                sellerPIPunchItems: responseData.sellerPIPunchItems,
                sellerGRNQCPunch: responseData.sellerGRNQCPunch,
                vendorPayments: vendorPayments,
                sellerComapanyDetails: sellerComapanyDetails.data,
                sellerDebitNotes: activeSellerDebitNotes,
                sellerDebitNoteItems: activeSellerDebitNoteItems,
                cancelledSellerDebitNotes: cancelledSellerDebitNotes,
                cancelledSellerDebitNoteItems: cancelledSellerDebitNoteItems,
                tdsSections: tdsSectionsRes.data.data
            }
            if(companyTotalPIAmountRes.data && companyTotalPIAmountRes.data[0]?.totalAmount){
                sellerPODetails.companyTotalPIAmount = companyTotalPIAmountRes.data[0].totalAmount
            }
            console.log("sellerPODetails", sellerPODetails)
            constructVendorPaymentSummary(sellerPODetails)
        } else {
            setIsLoading(false)
            dispatch(raiseToast({severity:'error', detail: "Payment terms missing in sellerPO", life: 3000}))
        }
    }

    const constructVendorPaymentSummary = async (sellerPODetails) => {
        
        if(typeof sellerPODetails.sellerPO.paymentTerms === 'string'){
            sellerPODetails.sellerPO.paymentTerms = JSON.parse(sellerPODetails.sellerPO.paymentTerms)
        }

        let seller_payment_terms = sellerPODetails.sellerPO.paymentTerms

        if(seller_payment_terms.payAdvDelivery){
            seller_payment_terms.payAdvDelivery = parseFloat(seller_payment_terms.payAdvDelivery)
        }
        if(seller_payment_terms.payAdvPO){
            seller_payment_terms.payAdvPO = parseFloat(seller_payment_terms.payAdvPO)
        }
        if(seller_payment_terms.payCredit){
            seller_payment_terms.payCredit = parseFloat(seller_payment_terms.payCredit)
        }
        if(seller_payment_terms.payOnDelivery){
            seller_payment_terms.payOnDelivery = parseFloat(seller_payment_terms.payOnDelivery)
        }
        if(seller_payment_terms.payPDCDelivery){
            seller_payment_terms.payPDCDelivery = parseFloat(seller_payment_terms.payPDCDelivery)
        }
        if(seller_payment_terms.creditPeriodId){
            seller_payment_terms.creditPeriodId = parseFloat(seller_payment_terms.creditPeriodId)
        }

        let isExpensePO = sellerPODetails.sellerPO.expenseCategoryId

        const activeVendorPayments = sellerPODetails.vendorPayments.filter(eachVendorPayment => ![6, 8, 11, 2].includes(eachVendorPayment.statusId))

        const sellerPaymentAmountTermsMapObj = {
            payAdvPO: "payAdvPOAmount",
            payAdvDelivery: "payAdvDeliveryAmount",
            payPDCDelivery: "payPDCDeliveryAmount",
            payOnDelivery: "payOnDeliveryAmount",
            payCredit: "payCreditAmount",
        }

        const sellerPaymentActualAmountTermsMapObj = {
            payAdvPO: "actualPayAdvPOAmount",
            payAdvDelivery: "actualPayAdvDeliveryAmount",
            payPDCDelivery: "actualPayPDCDeliveryAmount",
            payOnDelivery: "actualPayOnDeliveryAmount",
            payCredit: "actualPayCreditAmount",
        }

        const VPWiseSellerPOPaymentDetails = constructVPWiseSellerPOPaymentDetails(sellerPODetails, sellerPODetails.vendorPayments)
        
        const piPunchPaymentDetails = []

        const relatedCreditPeriod = companyCreditPeriods.find(eachCreditPeriod => eachCreditPeriod.creditPeriodId === sellerPODetails.sellerPO.paymentTerms.creditPeriodId)

        let paymentTerms = {
            payAdvPO: 0,
            payAdvDelivery: 0,
            payPDCDelivery: 0,
            payOnDelivery: 0,
            payCredit: 0,
            creditPeriodId: sellerPODetails.sellerPO?.paymentTerms.creditPeriodId,
            creditPeriod: relatedCreditPeriod?.creditPeriod ? relatedCreditPeriod.creditPeriod : 0
        }

        let lastPaymentTerm = "payAdvPO"

        let sellerPOPaymentTerms = sellerPODetails.sellerPO.paymentTerms

        if(sellerPOPaymentTerms.payAdvPO){
            paymentTerms.payAdvPO = sellerPOPaymentTerms.payAdvPO
            paymentTerms.payAdvPOAmount = round(sellerPOPaymentTerms.payAdvPO * sellerPODetails.sellerPO.totalItemAmountBeforeTax/100, 2)
            lastPaymentTerm = "payAdvPO"
        }
        if(sellerPOPaymentTerms.payAdvDelivery){
            paymentTerms.payAdvDelivery = sellerPOPaymentTerms.payAdvDelivery
            paymentTerms.payAdvDeliveryAmount = round(sellerPOPaymentTerms.payAdvDelivery * sellerPODetails.sellerPO.totalItemAmountBeforeTax/100, 2)
            lastPaymentTerm = "payAdvDelivery"
        }
        if(sellerPOPaymentTerms.payPDCDelivery){
            paymentTerms.payPDCDelivery = sellerPOPaymentTerms.payPDCDelivery
            paymentTerms.payPDCDeliveryAmount = round(sellerPOPaymentTerms.payPDCDelivery * sellerPODetails.sellerPO.totalItemAmountBeforeTax/100, 2)
            lastPaymentTerm = "payPDCDelivery"
        }
        if(sellerPOPaymentTerms.payOnDelivery){
            paymentTerms.payOnDelivery = sellerPOPaymentTerms.payOnDelivery
            paymentTerms.payOnDeliveryAmount = round(sellerPOPaymentTerms.payOnDelivery * sellerPODetails.sellerPO.totalItemAmountBeforeTax/100, 2)
            lastPaymentTerm = "payOnDelivery"
        }
        if(sellerPOPaymentTerms.payCredit){
            paymentTerms.payCredit = sellerPOPaymentTerms.payCredit
            paymentTerms.payCreditAmount = round(sellerPOPaymentTerms.payCredit * sellerPODetails.sellerPO.totalItemAmountBeforeTax/100, 2)
            lastPaymentTerm = "payCredit"
        }

        let tdsApplicablePaymentTerm = 'payPDCDelivery'

        let onlyAdvancePaymentExists = false 
        if(!paymentTerms.payOnDelivery && !paymentTerms.payCredit){
            onlyAdvancePaymentExists = true
        }

        if(onlyAdvancePaymentExists){
            if(paymentTerms.payAdvPO){
                tdsApplicablePaymentTerm = "payAdvPO"
            } else if(paymentTerms.payAdvDelivery){
                tdsApplicablePaymentTerm = "payAdvDelivery"
            }
        } else {
            if(paymentTerms.payCredit){
                tdsApplicablePaymentTerm = "payCredit"
            }
            if(paymentTerms.payOnDelivery){
                tdsApplicablePaymentTerm = "payOnDelivery"
            }
        }

        const lastPaymentAmountTerm = sellerPaymentAmountTermsMapObj[lastPaymentTerm]
        const lastActualPaymentAmountTerm = sellerPaymentActualAmountTermsMapObj[lastPaymentTerm]

        paymentTerms[lastPaymentAmountTerm] = round(paymentTerms[lastPaymentAmountTerm] + sellerPODetails.sellerPO.totalPOTax, 2)

        let isServiceProductExists = false
        sellerPODetails.sellerPOItems.map(eachSellerPOItem => {
            if(eachSellerPOItem.HSNCode?.toString().slice(0,2) && eachSellerPOItem.HSNCode?.toString().length === 6){
                isServiceProductExists = true
            }
        })

        if(sellerPODetails.sellerPIPunch){
            sellerPODetails.sellerPIPunch.map(eachSellerPIPunch => {
                if(eachSellerPIPunch.statusId === 1){

                    let nonReceivedNonShortQtyExists = false
                    let allPIProductsNotReceived = true
                    let onHoldQuantityExists = false

                    const relatedSellerPIPunchItems = sellerPODetails.sellerPIPunchItems.filter(eachSellerPIPunchItem => eachSellerPIPunchItem.sellerPIPunchId === eachSellerPIPunch.sellerPIPunchId)
                    
                    relatedSellerPIPunchItems.map(eachPIPunchItem => {
                        if(eachPIPunchItem.statusId === 1){
                            let relatedSellerGRNQCPunches = sellerPODetails.sellerGRNQCPunch.filter(eachSellerGRNQCPunch => eachSellerGRNQCPunch.sellerPIPunchId === eachPIPunchItem.sellerPIPunchId && eachPIPunchItem.buyerReqItemId === eachSellerGRNQCPunch.buyerReqItemId && eachSellerGRNQCPunch.statusId === 1)
                            if(isExpensePO){
                                relatedSellerGRNQCPunches = sellerPODetails.sellerGRNQCPunch.filter(eachSellerGRNQCPunch => eachSellerGRNQCPunch.sellerPIPunchId === eachPIPunchItem.sellerPIPunchId && eachPIPunchItem.materialId === eachSellerGRNQCPunch.materialId && eachSellerGRNQCPunch.statusId === 1)
                            }
                            relatedSellerGRNQCPunches = relatedSellerGRNQCPunches.sort((a, b) => b.sellerGRNQCPunchId - a.sellerGRNQCPunchId)

                            if(relatedSellerGRNQCPunches.length > 0){
                                const totalReceivedQty = _.sumBy(relatedSellerGRNQCPunches, (eachItem) => eachItem.receivedQuantity ? eachItem.receivedQuantity : 0)
                                const totalShortQty = _.sumBy(relatedSellerGRNQCPunches, (eachItem) => eachItem.shortQuantity ? eachItem.shortQuantity : 0)

                                if(totalReceivedQty + totalShortQty + 0.01 >= eachPIPunchItem.qty){
                                    allPIProductsNotReceived = false
                                }
                                const nonReceivedNonShortQty = round(eachPIPunchItem.qty - relatedSellerGRNQCPunches[0].receivedQuantity - relatedSellerGRNQCPunches[0].shortQuantity, 3)
                                
                                if(nonReceivedNonShortQty){
                                    nonReceivedNonShortQtyExists = true
                                }

                                const onHoldQuantity = round(relatedSellerGRNQCPunches[0].receivedQuantity - relatedSellerGRNQCPunches[0].acceptedQuantity - relatedSellerGRNQCPunches[0].rejectedQuantity, 3)
                                if(onHoldQuantity){
                                    onHoldQuantityExists = true
                                }
                            }
                        }
                    })

                    if(allPIProductsNotReceived){
                        console.log("entered pi not received")
                        return
                    }

                    //if(eachSellerPIPunch.sellerPIDocProof && eachSellerPIPunch.statusId === 1){
                    if(eachSellerPIPunch.statusId === 1){

                        let piTaxAmount = 0
                        let piTotalAmountBeforeTax = 0
                        let piTotalAmount = 0

                        let piActualTaxAmount = 0 
                        let piActualTotalAmountBeforeTax = 0
                        let piActualTotalAmount = 0
                        let piActualTDSAmount = 0

                        let piDebitNoteQty = 0
                        let piDebitNoteAmount = 0

                        relatedSellerPIPunchItems.map(eachPIPunchItem => {
                            if(eachPIPunchItem.statusId === 1){
                                let relatedSellerGRNQCPunches = sellerPODetails.sellerGRNQCPunch.filter(eachSellerGRNQCPunch => eachSellerGRNQCPunch.sellerPIPunchId === eachPIPunchItem.sellerPIPunchId && eachPIPunchItem.buyerReqItemId === eachSellerGRNQCPunch.buyerReqItemId && eachSellerGRNQCPunch.statusId === 1)
                                if(isExpensePO){
                                    relatedSellerGRNQCPunches = sellerPODetails.sellerGRNQCPunch.filter(eachSellerGRNQCPunch => eachSellerGRNQCPunch.sellerPIPunchId === eachPIPunchItem.sellerPIPunchId && eachPIPunchItem.materialId === eachSellerGRNQCPunch.materialId && eachSellerGRNQCPunch.statusId === 1)
                                }
                                relatedSellerGRNQCPunches = relatedSellerGRNQCPunches.sort((a, b) => b.sellerGRNQCPunchId - a.sellerGRNQCPunchId)

                                if(relatedSellerGRNQCPunches.length > 0){
                                    const GRNQCPunch = relatedSellerGRNQCPunches[0]
                                    let relatedSellerPOItem = sellerPODetails.sellerPOItems.find(eachSellerPOItem => eachSellerPOItem.buyerReqItemId === GRNQCPunch.buyerReqItemId)
                                    if(isExpensePO){
                                        relatedSellerPOItem = sellerPODetails.sellerPOItems.find(eachSellerPOItem => eachSellerPOItem.materialId === GRNQCPunch.materialId)
                                    }

                                    const unitPrice = relatedSellerPOItem.unitPrice
                                    let totalPriceBeforeTax = unitPrice * eachPIPunchItem.qty
                                    let taxAmount = 0

                                    let actualTotalPriceBeforeTax = 0
                                    let actualTaxAmount = 0
                                    let actualTDSAmount = 0

                                    if(totalPriceBeforeTax > 0){
                                        taxAmount = totalPriceBeforeTax * relatedSellerPOItem.GSTRate / 100
                                    }
                                    piTotalAmountBeforeTax += totalPriceBeforeTax
                                    piTaxAmount += taxAmount
                                    piTotalAmount += totalPriceBeforeTax + taxAmount

                                    const relatedSellerDebitNoteItems = sellerPODetails.sellerDebitNoteItems?.filter(eachDebitNoteItem => eachDebitNoteItem.sellerPIPunchItemId === eachPIPunchItem.sellerPIPunchItemId) || []
                                    let debitNoteQuantity = 0
                                    let debitNoteAmount = 0

                                    relatedSellerDebitNoteItems.map(eachDebitNoteItem => {
                                        debitNoteQuantity += eachDebitNoteItem.adjustedQty
                                        let debitNoteItemBeforeTax = round(eachDebitNoteItem.adjustedQty * eachDebitNoteItem.adjustedPricePerUnit, 2)
                                        let debitNoteItemTax = 0 
                                        if(relatedSellerPOItem.GSTRate){
                                            debitNoteItemTax = debitNoteItemBeforeTax * relatedSellerPOItem.GSTRate / 100
                                        }
                                        debitNoteAmount += round(debitNoteItemBeforeTax + debitNoteItemTax, 2)
                                    })
                                    piDebitNoteQty += debitNoteQuantity
                                    piDebitNoteAmount += debitNoteAmount

                                    const relatedCancelledSellerDebitNoteItems = sellerPODetails.cancelledSellerDebitNoteItems.filter(eachDebitNoteItem => eachDebitNoteItem.sellerPIPunchItemId === eachPIPunchItem.sellerPIPunchItemId) || []

                                    if(GRNQCPunch.acceptedQuantity || relatedCancelledSellerDebitNoteItems.length){
                                        let calcQuantity = round(eachPIPunchItem.qty - debitNoteQuantity, 3) //round(eachPIPunchItem.qty - GRNQCPunch.rejectedQuantity - GRNQCPunch.shortQuantity, 3)
                                        
                                        actualTotalPriceBeforeTax = round(unitPrice * calcQuantity, 2)
                                        if(relatedSellerPOItem.tdsValue){
                                            actualTDSAmount = round(relatedSellerPOItem.tdsValue * actualTotalPriceBeforeTax / 100, 2)
                                        }
                                    }
    
                                    if (actualTotalPriceBeforeTax > 0) {
                                        if (relatedSellerPOItem.GSTRate) {
                                            actualTaxAmount = actualTotalPriceBeforeTax * relatedSellerPOItem.GSTRate / 100
                                        }
                                    }
    
                                    piActualTotalAmountBeforeTax += actualTotalPriceBeforeTax
                                    piActualTaxAmount += round(actualTaxAmount, 2)
                                    piActualTDSAmount += round(actualTDSAmount, 2)
                                    piActualTotalAmount += parseFloat(parseFloat(actualTotalPriceBeforeTax + actualTaxAmount).toFixed(2))
                                }
                            }
                        })

                        if(eachSellerPIPunch.sellerPILogisticsWithTax){
                            let sellerPILogisticsBeforeTax = eachSellerPIPunch.sellerPILogisticsWithTax / (1 + (sellerPODetails.sellerPO.logisticsGSTRate / 100))

                            piTotalAmountBeforeTax = round(piTotalAmountBeforeTax + sellerPILogisticsBeforeTax, 2)
                            piActualTotalAmountBeforeTax = round(piActualTotalAmountBeforeTax + sellerPILogisticsBeforeTax, 2)

                            piTaxAmount = piTaxAmount + round(eachSellerPIPunch.sellerPILogisticsWithTax - sellerPILogisticsBeforeTax, 2)
                            piActualTaxAmount = piActualTaxAmount + round(eachSellerPIPunch.sellerPILogisticsWithTax - sellerPILogisticsBeforeTax, 2)

                            if(sellerPILogisticsBeforeTax && sellerPODetails.sellerPO.logisticsTDSValue){
                                piActualTDSAmount += round((sellerPILogisticsBeforeTax / sellerPODetails.sellerPO.logisticsTDSValue) / 100)
                            }

                            piTotalAmount += eachSellerPIPunch.sellerPILogisticsWithTax
                            piActualTotalAmount += eachSellerPIPunch.sellerPILogisticsWithTax
                        }

                        if(eachSellerPIPunch.tdsValue){
                            piActualTDSAmount = piActualTotalAmountBeforeTax * eachSellerPIPunch.tdsValue * 0.01
                        }

                        const relatedSellerDebitNotes = sellerPODetails.sellerDebitNotes.filter(eachDebitNote => eachDebitNote.sellerPIPunchId === eachSellerPIPunch.sellerPIPunchId)
                        const relatedSellerDebitNoteIds = relatedSellerDebitNotes.map(eachDebitNote => eachDebitNote.adjustmentNoteId)
                        const relatedSellerDebitNoteItems = sellerPODetails.sellerDebitNoteItems?.filter(eachDebitNoteItem => relatedSellerDebitNoteIds.includes(eachDebitNoteItem.adjustmentNoteId))

                        let piPaymentObj = {
                            sellerPIPunchId: eachSellerPIPunch.sellerPIPunchId,
                            docNo: eachSellerPIPunch.docNo,
                            sellerPINumber: eachSellerPIPunch.sellerPINumber,
                            piTaxAmount: round(piTaxAmount),
                            piActualTDSAmount: round(piActualTDSAmount),
                            piTotalAmountBeforeTax: piTotalAmountBeforeTax,
                            piTotalAmount: round(piTotalAmount),
                            piActualTaxAmount: round(piActualTaxAmount),
                            piActualTotalAmountBeforeTax: piActualTotalAmountBeforeTax,
                            piActualTotalAmount: round(piActualTotalAmount),
                            nonReceivedNonShortQtyExists: nonReceivedNonShortQtyExists,
                            onHoldQuantityExists: onHoldQuantityExists,
                            isPaymentOnHold: eachSellerPIPunch.isPaymentOnHold,
                            GRNDate: eachSellerPIPunch.createdAt,
                            piDebitNoteQty: piDebitNoteQty,
                            piDebitNoteAmount: piDebitNoteAmount,
                            sellerDebitNotes: relatedSellerDebitNotes,
                            sellerDebitNoteItems: relatedSellerDebitNoteItems
                        }
                        
                        if(paymentTerms.payAdvPO){
                            let payAdvPOAmount = parseFloat(piPaymentObj.piTotalAmountBeforeTax) * parseFloat(paymentTerms.payAdvPO) / 100
                            piPaymentObj.payAdvPOAmount = round(payAdvPOAmount)

                            let actualPayAdvPOAmount = parseFloat(piPaymentObj.piActualTotalAmountBeforeTax) * parseFloat(paymentTerms.payAdvPO) / 100
                            piPaymentObj.actualPayAdvPOAmount = round(actualPayAdvPOAmount)

                            let vpWisePayAdvPOAmount = parseFloat(piPaymentObj.piActualTotalAmount) * parseFloat(VPWiseSellerPOPaymentDetails.actualPayAdvPO) / 100
                            piPaymentObj.vpWisePayAdvPOAmount = round(vpWisePayAdvPOAmount)
                        } 
                        if(paymentTerms.payAdvDelivery){
                            let payAdvDeliveryAmount = parseFloat(piPaymentObj.piTotalAmountBeforeTax) * parseFloat(paymentTerms.payAdvDelivery) / 100
                            piPaymentObj.payAdvDeliveryAmount = round(payAdvDeliveryAmount)

                            let actualPayAdvDeliveryAmount = parseFloat(piPaymentObj.piActualTotalAmountBeforeTax) * parseFloat(paymentTerms.payAdvDelivery) / 100
                            piPaymentObj.actualPayAdvDeliveryAmount = round(actualPayAdvDeliveryAmount)

                            let vpWisePayAdvDeliveryAmount = parseFloat(piPaymentObj.piActualTotalAmount) * parseFloat(VPWiseSellerPOPaymentDetails.actualPayAdvDelivery) / 100
                            piPaymentObj.vpWisePayAdvDeliveryAmount = round(vpWisePayAdvDeliveryAmount)
                        }
                        if(paymentTerms.payPDCDelivery){
                            let payPDCDeliveryAmount = parseFloat(piPaymentObj.piTotalAmountBeforeTax) * parseFloat(paymentTerms.payPDCDelivery) / 100
                            piPaymentObj.payPDCDeliveryAmount = round(payPDCDeliveryAmount)

                            let actualPayPDCDeliveryAmount = parseFloat(piPaymentObj.piActualTotalAmountBeforeTax) * parseFloat(paymentTerms.payPDCDelivery) / 100
                            piPaymentObj.actualPayPDCDeliveryAmount = round(actualPayPDCDeliveryAmount)

                            let vpWisePayPDCDeliveryAmount = parseFloat(piPaymentObj.piActualTotalAmount) * parseFloat(VPWiseSellerPOPaymentDetails.actualPayPDCDelivery) / 100
                            piPaymentObj.vpWisePayPDCDeliveryAmount = round(vpWisePayPDCDeliveryAmount)
                        }
                        if(paymentTerms.payOnDelivery){
                            let payOnDeliveryAmount = parseFloat(piPaymentObj.piTotalAmountBeforeTax) * parseFloat(paymentTerms.payOnDelivery) / 100
                            piPaymentObj.payOnDeliveryAmount = round(payOnDeliveryAmount)

                            let actualPayOnDeliveryAmount= parseFloat(piPaymentObj.piActualTotalAmountBeforeTax) * parseFloat(paymentTerms.payOnDelivery) / 100
                            piPaymentObj.actualPayOnDeliveryAmount = round(actualPayOnDeliveryAmount)

                            let vpWisePayOnDeliveryAmount = parseFloat(piPaymentObj.piActualTotalAmount) * parseFloat(VPWiseSellerPOPaymentDetails.actualPayOnDelivery) / 100
                            piPaymentObj.vpWisePayOnDeliveryAmount = round(vpWisePayOnDeliveryAmount)
                        }
                        if(paymentTerms.payCredit){
                            let payCreditAmount = parseFloat(piPaymentObj.piTotalAmountBeforeTax) * parseFloat(paymentTerms.payCredit) / 100
                            piPaymentObj.payCreditAmount = round(payCreditAmount)

                            let actualPayCreditAmount= parseFloat(piPaymentObj.piActualTotalAmountBeforeTax) * parseFloat(paymentTerms.payCredit) / 100
                            piPaymentObj.actualPayCreditAmount = round(actualPayCreditAmount)

                            let vpWisePayCreditAmount = parseFloat(piPaymentObj.piActualTotalAmount) * parseFloat(VPWiseSellerPOPaymentDetails.actualPayCredit) / 100
                            piPaymentObj.vpWisePayCreditAmount = round(vpWisePayCreditAmount)
                        }

                        piPaymentObj[lastPaymentAmountTerm] = round( piPaymentObj[lastPaymentAmountTerm] + piPaymentObj.piTaxAmount )
                        piPaymentObj[lastActualPaymentAmountTerm] = round( piPaymentObj[lastActualPaymentAmountTerm] + piPaymentObj.piActualTaxAmount )

                        piPunchPaymentDetails.push(piPaymentObj)
                    }
                    else {
                        console.log("enter not 2")
                    }
                }
            })
        }

        let unavailableProducts = []
        let allProductsSubmittedFlag = false 

        let activeSellerGRNQCPunches = sellerPODetails.sellerGRNQCPunch.filter(eachSellerGRNQCPunch => eachSellerGRNQCPunch.statusId === 1)
        activeSellerGRNQCPunches.sort((a, b) => b.createdAt - a.createdAt)

        let firstSellerGRNQCPunch = activeSellerGRNQCPunches?.[0]

        sellerPODetails.sellerPOItems?.map(eachSellerPOItem => {
            let totalReceivedQty = 0

            let relatedSellerGRNQCPunches = sellerPODetails.sellerGRNQCPunch.filter(eachSellerGRNQCPunch => eachSellerGRNQCPunch.buyerReqItemId === eachSellerPOItem.buyerReqItemId && eachSellerGRNQCPunch.statusId === 1)
            if(isExpensePO){
                relatedSellerGRNQCPunches = sellerPODetails.sellerGRNQCPunch.filter(eachSellerGRNQCPunch => eachSellerGRNQCPunch.materialId === eachSellerPOItem.materialId && eachSellerGRNQCPunch.statusId === 1)
            }
            relatedSellerGRNQCPunches.sort((a, b) => b.createdAt - a.createdAt)

            if(relatedSellerGRNQCPunches.length > 0){
                const GRNQCPunch = relatedSellerGRNQCPunches[0]
                totalReceivedQty = GRNQCPunch.receivedQuantity
            }

            let availableQuantity = eachSellerPOItem.qty - totalReceivedQty
            if (availableQuantity === 0) {
                unavailableProducts.push(eachSellerPOItem)
            }
        })
        if (unavailableProducts.length === sellerPODetails.sellerPOItems.length) {
            allProductsSubmittedFlag = true
        }

        let vendorPaymentReqObj = {}

        vendorPaymentReqObj.paymentDate = new Date()

        if(activeVendorPayments.length >= 0){
            let totalAmountRequested = 0
            let totalAdvanceAmount = 0
            let totalAdvanceRequestedAmount = 0
            let documentSelectedFlag = false
            let isCashPaymentExists = false
            let isNonCashPaymentExists = false

            let totalTDSAmount = 0
            let TDSVendorPaymentOnAdvance

            let advancePOVendorPayments = []
            let advanceVendorPayments = []
            let PDCVendorPayments = []

            if(VPWiseSellerPOPaymentDetails.totalTDSAmount){
                totalTDSAmount = VPWiseSellerPOPaymentDetails.totalTDSAmount
            }
            
            activeVendorPayments.map(vp => {
                if(['payAdvPO', 'payAdvDelivery', 'payPDCDelivery'].includes(vp.paymentTerm)){
                    totalAdvanceRequestedAmount += vp.amount
                    totalAmountRequested += vp.amount
                    if(vp.tdsAmount){
                        totalAdvanceRequestedAmount += vp.tdsAmount
                        totalAmountRequested += vp.tdsAmount
                        TDSVendorPaymentOnAdvance = vp
                    }
                    if(vp.paymentTerm === 'payAdvPO'){
                        advancePOVendorPayments.push(vp)
                    }
                    if(vp.paymentTerm === 'payAdvDelivery'){
                        advanceVendorPayments.push(vp)
                    }
                    if(vp.paymentTerm === 'payPDCDelivery'){
                        PDCVendorPayments.push(vp)
                    }
                } else {
                    totalAmountRequested += vp.amount
                    if(vp.tdsAmount){
                        totalAmountRequested += vp.tdsAmount
                    }
                }

                if(vp.paymentMode === 'CASH'){
                    isCashPaymentExists = true
                } else if(!vp.tdsAmount){
                    isNonCashPaymentExists = true
                }
            })

            if(paymentTerms.payAdvPOAmount){
                totalAdvanceAmount += VPWiseSellerPOPaymentDetails.actualPayAdvPOAmount
                if(totalAdvanceRequestedAmount + 1 < totalAdvanceAmount){
                    vendorPaymentReqObj.paymentTerm = 'payAdvPO' 
                    vendorPaymentReqObj.initialPaymentTerm = 'payAdvPO' 
                    vendorPaymentReqObj.selectedDocument = 'sellerpo'
                    vendorPaymentReqObj.totalAmount = sellerPODetails.sellerPO.totalPOAmount
                    vendorPaymentReqObj.amountRequested = totalAdvanceRequestedAmount
                    vendorPaymentReqObj.payableAmount = parseFloat(parseFloat(totalAdvanceAmount - totalAdvanceRequestedAmount).toFixed(2)) 
                    if(onlyAdvancePaymentExists && totalTDSAmount && !TDSVendorPaymentOnAdvance){
                        vendorPaymentReqObj.payableAmount = vendorPaymentReqObj.payableAmount - totalTDSAmount
                        vendorPaymentReqObj.tdsAmount = totalTDSAmount
                    }
                    documentSelectedFlag = true
                }
            }
            
            if(paymentTerms.payAdvDeliveryAmount && !documentSelectedFlag){
                totalAdvanceAmount += VPWiseSellerPOPaymentDetails.actualPayAdvDeliveryAmount
                if(totalAdvanceRequestedAmount + 1 < totalAdvanceAmount){
                    vendorPaymentReqObj.paymentTerm = 'payAdvDelivery' 
                    vendorPaymentReqObj.initialPaymentTerm = 'payAdvDelivery' 
                    vendorPaymentReqObj.selectedDocument = 'sellerpo'
                    vendorPaymentReqObj.totalAmount = sellerPODetails.sellerPO.totalPOAmount
                    vendorPaymentReqObj.amountRequested = totalAdvanceRequestedAmount
                    vendorPaymentReqObj.payableAmount = parseFloat(parseFloat(totalAdvanceAmount - totalAdvanceRequestedAmount).toFixed(2))
                    if(onlyAdvancePaymentExists && totalTDSAmount && !TDSVendorPaymentOnAdvance && !paymentTerms.payAdvPOAmount){
                        vendorPaymentReqObj.payableAmount = vendorPaymentReqObj.payableAmount - totalTDSAmount
                        vendorPaymentReqObj.tdsAmount = totalTDSAmount
                    }
                    documentSelectedFlag = true
                }
            }

            if(paymentTerms.payPDCDeliveryAmount && !documentSelectedFlag){
                totalAdvanceAmount += VPWiseSellerPOPaymentDetails.actualPayPDCDeliveryAmount
                if(totalAdvanceRequestedAmount + 1 < totalAdvanceAmount){
                    vendorPaymentReqObj.paymentTerm = 'payPDCDelivery' 
                    vendorPaymentReqObj.initialPaymentTerm = 'payPDCDelivery' 
                    vendorPaymentReqObj.selectedDocument = 'sellerpo'
                    vendorPaymentReqObj.totalAmount = sellerPODetails.sellerPO.totalPOAmount
                    vendorPaymentReqObj.amountRequested = totalAdvanceRequestedAmount
                    vendorPaymentReqObj.payableAmount = parseFloat(parseFloat(totalAdvanceAmount - totalAdvanceRequestedAmount).toFixed(2))
                    if(onlyAdvancePaymentExists && totalTDSAmount && !TDSVendorPaymentOnAdvance && !paymentTerms.payAdvDelivery){
                        vendorPaymentReqObj.payableAmount = vendorPaymentReqObj.payableAmount - totalTDSAmount
                        vendorPaymentReqObj.tdsAmount = totalTDSAmount
                    }
                    vendorPaymentReqObj.paymentDate = new Date().setDate(new Date().getDate() + paymentTerms.creditPeriod)
                    vendorPaymentReqObj.minPaymentDate = vendorPaymentReqObj.paymentDate

                    let firstGRNQCDate = firstSellerGRNQCPunch ? new Date(firstSellerGRNQCPunch.processedDate).getTime() : null
                    if(firstGRNQCDate){
                        vendorPaymentReqObj.paymentDate = new Date(new Date(firstGRNQCDate).setDate(new Date(firstGRNQCDate).getDate() + paymentTerms.creditPeriod))
                        vendorPaymentReqObj.minPaymentDate = vendorPaymentReqObj.paymentDate
                    }
                    documentSelectedFlag = true
                }
            }

            if(true){
                piPunchPaymentDetails.map(eachPiPaymentDetail => {
                    let piRelatedVendorPayments = []
                    let piOnDeliveryRequestedAmount = 0
                    let piCreditRequestedAmount = 0
                    let piTotalAmountRequested = 0

                    let TDSAmount = 0
                    let TDSVendorPayment

                    let onDeliveryVendorPayments = []
                    let creditVendorPayments = []

                    if(eachPiPaymentDetail.piActualTDSAmount){ 
                        TDSAmount = eachPiPaymentDetail.piActualTDSAmount
                    }

                    activeVendorPayments.map(vp => {
                        if(vp.sellerPIPunchId && vp.sellerPIPunchId === eachPiPaymentDetail.sellerPIPunchId){
                            piRelatedVendorPayments.push(vp)
                            if(vp.paymentTerm === 'payOnDelivery'){
                                piOnDeliveryRequestedAmount += vp.amount
                                if(vp.tdsAmount){
                                    piOnDeliveryRequestedAmount += vp.tdsAmount
                                }
                                onDeliveryVendorPayments.push(vp)
                            }
                            if(vp.paymentTerm === 'payCredit'){
                                console.log("vp.paymentTerm === 'payCredit'")
                                piCreditRequestedAmount += vp.amount
                                if(vp.tdsAmount){
                                    piCreditRequestedAmount += vp.tdsAmount
                                }
                                creditVendorPayments.push(vp)
                            }
                            if(vp.tdsAmount){
                                TDSVendorPayment = vp
                            }
                        }
                    })

                    eachPiPaymentDetail.onDeliveryVendorPayments = onDeliveryVendorPayments 
                    eachPiPaymentDetail.creditVendorPayments = creditVendorPayments

                    if(documentSelectedFlag){
                        console.log("documentSelectedFlag", documentSelectedFlag, eachPiPaymentDetail)
                        return
                    }

                    if(eachPiPaymentDetail.vpWisePayAdvPOAmount){
                        piTotalAmountRequested += eachPiPaymentDetail.vpWisePayAdvPOAmount
                    }
                    if(eachPiPaymentDetail.vpWisePayAdvDeliveryAmount){
                        piTotalAmountRequested += eachPiPaymentDetail.vpWisePayAdvDeliveryAmount
                    }
                    if(eachPiPaymentDetail.vpWisePayPDCDeliveryAmount){
                        piTotalAmountRequested += eachPiPaymentDetail.vpWisePayPDCDeliveryAmount
                    }

                    if(eachPiPaymentDetail.vpWisePayOnDeliveryAmount && !eachPiPaymentDetail.isPaymentOnHold && !eachPiPaymentDetail.nonReceivedNonShortQtyExists && !eachPiPaymentDetail.onHoldQuantityExists){
                        if(Math.abs(eachPiPaymentDetail.piTotalAmount - eachPiPaymentDetail.piActualTotalAmount) >= 0){
                            let vpWisePayCreditAmount = 0 
                            if(eachPiPaymentDetail.vpWisePayCreditAmount){
                                vpWisePayCreditAmount = eachPiPaymentDetail.vpWisePayCreditAmount
                            }
                            let actualAdvancePaymentPlusOnDelivery = parseFloat(parseFloat(eachPiPaymentDetail.piActualTotalAmount - vpWisePayCreditAmount).toFixed(2))

                            if(piTotalAmountRequested + piOnDeliveryRequestedAmount + 1 < actualAdvancePaymentPlusOnDelivery){
                                vendorPaymentReqObj.paymentTerm = 'payOnDelivery' 
                                vendorPaymentReqObj.initialPaymentTerm = 'payOnDelivery' 
                                vendorPaymentReqObj.selectedDocument = eachPiPaymentDetail.sellerPIPunchId
                                vendorPaymentReqObj.totalAmount = eachPiPaymentDetail.piActualTotalAmount
                                vendorPaymentReqObj.amountRequested = parseFloat(piTotalAmountRequested.toFixed(2))
                                
                                vendorPaymentReqObj.payableAmount = parseFloat(parseFloat(actualAdvancePaymentPlusOnDelivery - piTotalAmountRequested - piOnDeliveryRequestedAmount).toFixed(2))

                                if(TDSAmount && !TDSVendorPayment && vendorPaymentReqObj.payableAmount - TDSAmount > 0){
                                    vendorPaymentReqObj.payableAmount = parseFloat(parseFloat(vendorPaymentReqObj.payableAmount - TDSAmount).toFixed(2))
                                    vendorPaymentReqObj.tdsAmount = TDSAmount
                                }
                                documentSelectedFlag = true
                            } else {
                                piTotalAmountRequested += eachPiPaymentDetail.vpWisePayOnDeliveryAmount
                            }
                        } else {
                            piTotalAmountRequested += eachPiPaymentDetail.vpWisePayOnDeliveryAmount
                        }
                    }

                    if(eachPiPaymentDetail.vpWisePayCreditAmount && !documentSelectedFlag && !eachPiPaymentDetail.isPaymentOnHold && !eachPiPaymentDetail.nonReceivedNonShortQtyExists && !eachPiPaymentDetail.onHoldQuantityExists){
                        if(Math.abs(eachPiPaymentDetail.piTotalAmount - eachPiPaymentDetail.piActualTotalAmount) >= 0){
                            if(piTotalAmountRequested + piCreditRequestedAmount + 1 < eachPiPaymentDetail.piActualTotalAmount){
                                vendorPaymentReqObj.paymentTerm = 'payCredit' 
                                vendorPaymentReqObj.initialPaymentTerm = 'payCredit' 
                                vendorPaymentReqObj.selectedDocument = eachPiPaymentDetail.sellerPIPunchId
                                vendorPaymentReqObj.totalAmount = eachPiPaymentDetail.piActualTotalAmount
                                vendorPaymentReqObj.amountRequested = parseFloat(piTotalAmountRequested.toFixed(2))
                                vendorPaymentReqObj.payableAmount = parseFloat(parseFloat(eachPiPaymentDetail.piActualTotalAmount - piTotalAmountRequested - piCreditRequestedAmount).toFixed(2))
                                
                                if(TDSAmount && !TDSVendorPayment){
                                    vendorPaymentReqObj.payableAmount = parseFloat(parseFloat(vendorPaymentReqObj.payableAmount - TDSAmount).toFixed(2))
                                    vendorPaymentReqObj.tdsAmount = TDSAmount
                                }
                                
                                if(paymentTerms.payCredit){
                                    let creditPeriod = paymentTerms.creditPeriod
                                    let relatedPurchaseInvoice = sellerPODetails.sellerPIPunch.find(eachSellerPIPunch => eachSellerPIPunch.sellerPIPunchId === eachPiPaymentDetail.sellerPIPunchId) //{}//bulkposeller.piPunchCount.find(obj => obj.piPunchNo === eachPiPaymentDetail.piPunchNo)
                                    
                                    let relatedGRNQCs = sellerPODetails.sellerGRNQCPunch.filter(eachSellerGRNQCPunch => eachSellerGRNQCPunch.sellerPIPunchId === relatedPurchaseInvoice.sellerPIPunchId && eachSellerGRNQCPunch.statusId === 1)
                                    let firstRelatedGRNQC = null

                                    if(relatedGRNQCs.length > 0){
                                        firstRelatedGRNQC = relatedGRNQCs[0]
                                    }
                                    if(!firstRelatedGRNQC.processedDate){
                                        //M.toast({classes:'red', html: `product received date not found on pipunch no : ${eachPiPaymentDetail.piPunchNo}`})
                                    }
                                    let piPunchDate = new Date(firstRelatedGRNQC.processedDate).getTime()
                                    
                                    if(piPunchDate){
                                        vendorPaymentReqObj.paymentDate = new Date(new Date(piPunchDate).setDate(new Date(piPunchDate).getDate() + creditPeriod))
                                        vendorPaymentReqObj.minPaymentDate = vendorPaymentReqObj.paymentDate
                                    }
                                }
                                documentSelectedFlag = true
                            }
                        } 
                    }

                })
            }

            let sellerPOPaymentDetails = {
                totalAdvanceAmount,
                totalAdvanceRequestedAmount,
                totalAmountRequested,
                isCashPaymentExists,
                isNonCashPaymentExists,
                tdsApplicablePaymentTerm,
                onlyAdvancePaymentExists,
                advancePOVendorPayments,
                advanceVendorPayments,
                PDCVendorPayments,
                piPunchPaymentDetails,
                VPWiseSellerPOPaymentDetails,
                lastPaymentTerm,
                allProductsSubmittedFlag,
                totalTDSAmount,
                isServiceProductExists,
                companyTotalPIAmount: sellerPODetails.companyTotalPIAmount,
                sellerComapanyDetails: sellerPODetails.sellerComapanyDetails
            }
            console.log("sellerPOPaymentDetails", sellerPOPaymentDetails)

            if(isCashPaymentExists){
                vendorPaymentReqObj.paymentMode = 'CASH'
            } else if(vendorPaymentReqObj.paymentTerm === 'payPDCDelivery'){
                vendorPaymentReqObj.paymentMode = 'CHEQUE'
            } else if(vendorPaymentReqObj.paymentTerm === 'payCredit'){
                vendorPaymentReqObj.paymentMode = 'CREDIT'
            } else {
                vendorPaymentReqObj.paymentMode = 'BANK TRANSFER'
            }

            if(vendorPaymentReqObj.payableAmount){
                vendorPaymentReqObj.payableAmount = round(vendorPaymentReqObj.payableAmount)
            }

            setSellerPOPaymentDetails(sellerPOPaymentDetails)
            setVendorPaymentReq(vendorPaymentReqObj)
            setPaymentTerms(paymentTerms)
        }

        setIsLoading(false)
    }

    const renderSellerPOSummarySkeleton = () => {
        return(
            <div className="card mb-3">
                <div className="border-round border-1 surface-border p-4 surface-card">
                    <RectangleRowSkeleton />
                </div>
            </div>
        )
    }

    const renderPaymentSummarySkeleton = () => {
        return(
            <div className="card mb-3">
                <div className="border-round border-1 surface-border p-4 surface-card">
                    <div className="flex flex-column justify-content-evenly">
                       <TableSkeleton />
                    </div>
                </div>
            </div>
        )
    }

    const renderPaymentRequestSkeleton = () =>{
        return(
            <>
            <div className="card mb-3">
                <div className="border-round border-1 surface-border p-4 surface-card">
                    <div className="flex flex-column justify-content-evenly"></div>
                        <RectangleRowSkeleton />
                        <RectangleRowSkeleton />
                    </div>
                </div>
            </>
        )
    }

    const renderPaymentHistorySkeleton = () => {
        return(
            <div className="card mb-3">
                <div className="border-round border-1 surface-border p-4 surface-card">
                    <div className="flex flex-column justify-content-evenly">
                    <TableSkeleton />
                    </div>
                </div>
            </div>
        )
    }

    return (
        <>  
            { sellerPO ?
                <div className="vendor-payment-summary-tab flex flex-column sm:col-12">
                    <h3 className="text-center mt-2">{sellerPO?.docNo}</h3>
                    <div className="flex flex-row justify-content-between mb-0">
                        <div className="flex custom_heading1 mb-1">Seller PO Summary</div>
                        <div className="flex custom_heading1 mr-2 text-600">Status: <b className="text-800 ml-1">REQUESTED</b></div>
                    </div>
                    {
                        isLoading ?
                            renderSellerPOSummarySkeleton()
                            :
                            <SellerPOSummary
                                sellerPO={sellerPO}
                                sellerPOPaymentDetails={sellerPOPaymentDetails}
                                sellerDebitNoteItems={sellerDebitNoteItems}
                                sellerDebitNotes={sellerDebitNotes}
                                materialDetails={materialDetails}
                                sellerPIPunchItems={sellerPIPunchItems}
                                setIsLoading={setIsLoading}
                            />
                    }
                    
                    <p className="flex custom_heading1 mb-1 mt-0">Payment Summary</p>
                    {
                        isLoading ?
                            renderPaymentSummarySkeleton()
                            :
                            <PaymentSummary
                                sellerPOPaymentDetails={sellerPOPaymentDetails}
                                sellerPO={sellerPO}
                                sellerPOItems={sellerPOItems}
                                sellerPIPunch={sellerPIPunch}
                                sellerPIPunchItems={sellerPIPunchItems}
                                sellerGRNQCPunch={sellerGRNQCPunch}
                                paymentTerms={paymentTerms}
                                vendorPayments={vendorPayments}
                                vendorPaymentReq={vendorPaymentReq}
                                setVendorPaymentReq={setVendorPaymentReq}
                                getSellerPO={getSellerPO}
                                setIsLoading={setIsLoading}
                            />
                    }
                    <div className="flex custom_heading1 mb-1">Payment Request</div>
                    {
                        isLoading ?
                            renderPaymentRequestSkeleton()
                            :
                            <PaymentRequest
                                getSellerPO={getSellerPO}
                                sellerPIPunch={sellerPIPunch}
                                sellerGRNQCPunch={sellerGRNQCPunch}
                                sellerPOPaymentDetails={sellerPOPaymentDetails}
                                sellerPO={sellerPO}
                                sellerPOItems={sellerPOItems}
                                paymentTerms={paymentTerms}
                                vendorPayments={vendorPayments}
                                vendorPaymentReq={vendorPaymentReq}
                                setIsLoading={setIsLoading}
                                prendingApprovalsExist={pendingApprovalsExist}
                                pmCompanyConfig={pmCompanyConfig}
                            />
                    }
                    <div className="flex custom_heading1 mb-1">Payment History</div>
                    {
                        isLoading ?
                            renderPaymentHistorySkeleton()
                            :
                            <PaymentHistory
                                getSellerPO={getSellerPO}
                                vendorPayments={vendorPayments}
                                sellerPIPunch={sellerPIPunch}
                                setVendorPayments={setVendorPayments}
                                statusList={statusList}
                                setIsLoading={setIsLoading}
                                approvals={approvals}
                                approvalInstances={approvalInstances}
                            />
                    }
                </div> : ""
            }
            <Loading visible={isLoading} />
        </>
    )
}

export default VendorPaymentSummary;